$(function () {
    $(document).on('click', '.filter-attachment-tag', function (e) {
        e.preventDefault();
        var url = $(this).data('filter_url');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'POST', url: url, async: false, dataType: 'json',
                success: function (data) {
                    console.log(data);
                    $('#attachments_list').html(data.data.content);
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    $(document).on('click', 'a.edit-attachment-tags', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        if (typeof url !== "undefined") {
            //console.log(url);
            $.ajax({
                type: 'POST', url: url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        console.log(data);
                        $('#editAttachmentTags').html(data.data.content).on('shown.bs.modal', function () {
                            var select = $('#editAttachmentTags select[autofocus]:first');
                            var input = $('#editAttachmentTags input[autofocus]:first');
                            if (select.length > 0) {
                                select.focus();
                            }
                            if (input.length > 0) {
                                input.focus();
                            }
                            var choice = $('#editAttachmentTags select.tag_choice');
                            if (choice.length > 0) {
                                let choices = new Choices(choice[0], {
                                    removeItemButton: true,
                                    placeholder: true,
                                    loadingText: 'Načítání...',
                                    noResultsText: 'Nebyly nalezeny žádné výsledky',
                                    noChoicesText: 'Žádné možnosti na výběr',
                                    itemSelectText: 'Klikněte pro výběr',
                                    uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
                                });
                                $('#editAttachmentTags #tag-switch').change(function () {
                                    if ($(this).prop('checked')) {
                                        $('#editAttachmentTags #tag-select').addClass('d-none');
                                        $('#editAttachmentTags #tag-new').removeClass('d-none');
                                    } else {
                                        $('#editAttachmentTags #tag-new').addClass('d-none');
                                        $('#editAttachmentTags #tag-select').removeClass('d-none');
                                    }
                                });
                            }
                        }).on('hidden.bs.modal', function () {
                            $('#editAttachmentTags').html('');
                        });
                        $('#attachment-tags-api-form').on('submit', function (e) {
                            e.preventDefault();
                            if (typeof tinymce !== 'undefined') {
                                tinymce.triggerSave();
                                if (tinymce.activeEditor !== null) {
                                    tinymce.activeEditor.save();
                                }
                            }
                            var form = $(this);
                            var actionUrl = form.attr('action');
                            var form_data = new FormData(form[0]);
                            $.ajax({
                                type: "POST",
                                url: actionUrl,
                                data: form_data,
                                enctype: "multipart/form-data",
                                processData: false,
                                contentType: false,
                                success: function (data) {
                                    if (data.status == 'success') {
                                        refresh_url = $('#attachments_list').data('refresh_url');
                                        if (typeof refresh_url !== "undefined") {
                                            $.ajax({
                                                type: 'POST', url: refresh_url, async: false, dataType: 'json',
                                                success: function (data) {
                                                    console.log(data);
                                                    $('#attachments_list').html(data.data.content);
                                                },
                                                error: function (data) { // if error occured
                                                    bootbox.alert('Chyba při provádění operace');
                                                }
                                            });
                                        }
                                    } else {
                                        bootbox.alert(data.msg);
                                    }
                                },
                                error: function (data) { // if error occured
                                    bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
                                },
                                complete: function () {
                                    $('#editAttachmentTags').html('');
                                }
                            });
                            $('#editAttachmentTags').modal('hide');
                        });
                        $('#editAttachmentTags').modal('show');
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });
});